/**
 * @fileoverview
 * Selected Audit Type Service - Global selected audit type for the application header.
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Injectable, signal } from '@angular/core';
import { STORAGE_KEYS } from '@core/constants';
import { StorageUtil } from '@core/utils';

const DEFAULT_AUDIT_TYPE = 'Regular';
const ALLOWED_AUDIT_TYPES = new Set(['Regular', 'Surprise']);

@Injectable({
  providedIn: 'root',
})
export class SelectedAuditTypeService {
  private readonly selectedAuditTypeSignal = signal<string>(this.loadFromStorage());

  readonly selectedAuditType = this.selectedAuditTypeSignal.asReadonly();

  setSelectedAuditType(auditType: string | null | undefined): void {
    const next = this.normalize(auditType);
    this.selectedAuditTypeSignal.set(next);
    StorageUtil.setLocal(STORAGE_KEYS.SELECTED_AUDIT_TYPE, next);
  }

  clear(): void {
    this.selectedAuditTypeSignal.set(DEFAULT_AUDIT_TYPE);
    StorageUtil.removeLocal(STORAGE_KEYS.SELECTED_AUDIT_TYPE);
  }

  private loadFromStorage(): string {
    const stored = StorageUtil.getLocal<string>(STORAGE_KEYS.SELECTED_AUDIT_TYPE);
    return this.normalize(stored);
  }

  private normalize(value: string | null | undefined): string {
    if (value && ALLOWED_AUDIT_TYPES.has(value)) {
      return value;
    }
    return DEFAULT_AUDIT_TYPE;
  }
}
